import {connect} from 'react-redux';
import {SingleSelect as Component} from '../SingleSelect';
import {cscqSubmit, cscqSelectOption} from '@learningblocks/exp-redux';

/**
 * mapStateToProps - This function maps the state from the Redux store to the component's props.
 * It allows us to extract specific data from the Redux store state and use them as props within our React component.
 *
 * @param {Object} state - The entire state of the Redux store.
 * @param {Object} ownProps - The current props of the component.
 *
 * @returns {Object} - Returns an object which populates the props of our component.
 */
function mapStateToProps(state, ownProps) {
  // Find the entry in the store state using the provided id.
  const entry = state.cscq[ownProps.id];

  if (!entry) {
    // If no matching entry is found, return the original ownProps.
    return ownProps;
  }

  const disabledList = entry.disabled || [];
  const totalAttempts = ownProps.totalAttempts - disabledList.length;
  const complete = disabledList.includes(ownProps.answerId[0]) || totalAttempts === 0;

  const updatedOptions = ownProps.options.map(option => {
    // If the option's id exists in the "disabled" array of the "entry", set "selected" and "disabled" to true.
    if (disabledList.includes(option.id)) {
        return {
            ...option,
            selected: true,
            disabled: true
        };
    } else if (option.id === entry.selected && !complete) {
        return {
            ...option,
            selected: true
        };
    }
    // Return the option unchanged if none of the above conditions are met.
    return option;
  });
  
  return {
      ...ownProps,
      options: updatedOptions,
      totalAttempts: totalAttempts,
      complete: complete
  };
}

/**
 * mapDispatchToProps - Maps dispatch actions to the component's props.
 * This allows our React component to dispatch actions to modify the state in the Redux store.
 *
 * @param {Function} dispatch - The dispatch function from the Redux store.
 *
 * @returns {Object} - Returns an object with dispatch action functions.
 */
function mapDispatchToProps(dispatch) {
  return {
    // Dispatch the cscqSelectOption action.
    selectOption: (params) => {
      dispatch(cscqSelectOption(params));
    },
    // Dispatch the cscqSubmit action.
    submitAnswer: (id) => {
      dispatch(cscqSubmit(id));
    },
  };
}

// Connect our component to the Redux store.
// This HOC (Higher Order Component) provides our component with props from the store state (mapStateToProps) and dispatch actions (mapDispatchToProps).
export const SingleSelectReduxNew = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
